import { render, staticRenderFns } from "./uploadFilePage.vue?vue&type=template&id=14ad33e4&"
import script from "./uploadFilePage.vue?vue&type=script&lang=js&"
export * from "./uploadFilePage.vue?vue&type=script&lang=js&"
import style0 from "./uploadFilePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports